export default "__VITE_ASSET__BEPQzi4A__"